// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#user-account-list .stickyNavbar[data-v-7ae0a4df] {\n  padding-bottom: 5px !important;\n}\n#user-account-list .stickyNavbar .container-default[data-v-7ae0a4df] {\n  padding-top: 0;\n  padding-bottom: 5px;\n}", ""]);
// Exports
module.exports = exports;
